import protoRoot from "../proto-root";

const name = "changeCameraStationRecordingModeRpcRequest";

function create(mode: CameraStationRecordingMode) {
  const CameraStationRecordingModeEnum = protoRoot.lookupEnum("comm.CameraStationRecordingMode");
  const ChangeCameraStationRecordingModeRPCRequest = protoRoot.lookupType(
    "comm.ChangeCameraStationRecordingModeRPCRequest"
  );
  const request = ChangeCameraStationRecordingModeRPCRequest.create({
    mode: CameraStationRecordingModeEnum.values[mode]
  });

  return { payload: request, name };
}

const changeCameraStationRecordingModeRpcRequest = { create, name };

export default changeCameraStationRecordingModeRpcRequest;
